import * as React from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import InfoIcon from 'assets/images/InfoIcon.svg';
import NormalButton from 'components/system/atoms/buttons/NormalButton';

/* ************ Style ************ */
const useStyles = makeStyles()((theme) => ({
  paper: {
    backgroundColor: theme.palette.common.black,
    minHeight: '276px',
    width: '640px',
  },
  content: {
    alignItems: 'start',
    display: 'flex',
    padding: '40px 8px 0px 40px ',
    flexDirection: 'column',
  },
  defaultBox: {
    margin: '8px 0 0 24px',
  },
  defaultText: {
    color: theme.palette.common.white,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    fontSize: '21px',
  },
  action: {
    padding: '0px 40px 16px 40px ',
    display: 'flex',
    justifyContent: 'space-between',
  },
  detailmsg: {
    color: theme.palette.common.white,
    fontSize: 24,
    overflow: 'hidden',
  },
  buttonIcon: {
    height: 80,
    width: 200,
    fontSize: 24.5,
    borderRadius: 12,
    backgroundColor: '#FF3E3E',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#FF3E3E',
    },
    '&:active': {
      backgroundColor: '#FF7070',
    },
  },
  buttonOk: {
    backgroundColor: '#FF3E3E',
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: '#FF3E3E',
    },
    '&:active': {
      backgroundColor: '#FF7070',
    },
  },
  buttonCancel: {
    backgroundColor: '#BCBCBC',
    color: theme.palette.common.black,
    '&:hover': {
      backgroundColor: '#BCBCBC',
    },
    '&:active': {
      backgroundColor: '#D3D3D3',
    },
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
  },
  titleContent: {
    fontSize: 24,
    color: '#D3D3D3',
  },
}));

type DialogProps = {
  open: boolean;
  title: string;
  msg: string;
  detailMsg?: string;
  allSettingSendLabel?: string;
  partSettingSendLabel?: string;
  leftSelect: () => void;
  rightSelect: () => void;
  onClose: () => void;
  children?: React.ReactNode;
  addClass?: {
    contentBox?: string;
    contentText?: string;
  };
};

const SelectConfirmDialog: React.FC<React.PropsWithChildren<DialogProps>> = ({
  open,
  msg,
  title,
  detailMsg,
  leftSelect,
  allSettingSendLabel,
  rightSelect,
  partSettingSendLabel,
  children,
  addClass,
  onClose
}) => {
  const { classes } = useStyles();

  return (
    <Dialog
      classes={{
        paper: classes.paper,
      }}
      open={open}
      onClose={onClose}
      maxWidth={false}>
      <DialogContent
        classes={{
          root: classes.content,
        }}>
        <div className={classes.title}>
          <img src={InfoIcon} alt="Info" />
          <div className={classes.titleContent}>{title}</div>
        </div>
        <Box className={`${classes.defaultBox} ${addClass?.contentBox}`}>
          <DialogContentText className={`${classes.defaultText} ${addClass?.contentText}`}>{msg}</DialogContentText>
          {detailMsg && (
            <DialogContentText
              classes={{
                root: classes.detailmsg,
              }}>
              {detailMsg}
            </DialogContentText>
          )}
          {children}
        </Box>
      </DialogContent>
      <DialogActions
        classes={{
          root: classes.action,
        }}>
        <NormalButton onClick={leftSelect} className={`${classes.buttonIcon} ${classes.buttonOk}`}>
          {allSettingSendLabel}
        </NormalButton>
        <NormalButton onClick={rightSelect} className={`${classes.buttonIcon} ${classes.buttonOk}`}>
          {partSettingSendLabel}
        </NormalButton>
        <NormalButton onClick={onClose} className={`${classes.buttonIcon} ${classes.buttonCancel}`}>
          閉じる
        </NormalButton>
      </DialogActions>
    </Dialog>
  );
};

export default SelectConfirmDialog;
